import Component from '../abstracts/Component';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';

export default class HeaderComponent extends Component {

  get SELECTORS() {
    return {
      stickyHeader: '[data-sticky-header]',
      burgerMenu: '[data-trigger-menu]',
      navBar: '[data-navbar]',
      backMainMenu: '[data-close-menu-layers]',
      submenuLinks: "[data-menu-submenu='true']",
      submenuAccessibilityButton: '[data-navigation-accessibility-button]',
      menuLayers: '[data-menu-layers]',
      menuSubLayers: '[data-menu-panel]',
      headerMenu: '[data-header-menu]',
      searchBtn: '[data-trigger-search]',
      searchLayer: '[data-search-layer]',
      searchLayerInput: '[data-search-layer] .search-layer__form .aa-Input',
      redirectLink: '[data-card-href]',
      wishlistIcon: '[data-wishlist-icon]',
      wishlistCounter: '[data-wishlist-qty]',
      myaccountIcon: '#myaccount-header',
      myAccountLayerAccessibiltyBtn: '[data-myaccountheader-accessibility-button]',
      myAccountLayer: '#myAccountHeaderContent',
    };
  }

  get CLASSES() {
    return {
      iconWishlistEmpty: "icon-wishlist-empty",
      iconWishlistFull: "icon-wishlist-full",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    // to reset focus after close submenu
    this.originalSubmenuLink = null;
  }

  readDOM() {
    return {
      stickyHeader: document.querySelector(this.SELECTORS.stickyHeader),
      headerMenu: document.querySelector(this.SELECTORS.headerMenu),
      burgerMenu: this.$component.querySelector(this.SELECTORS.burgerMenu),
      navBar: this.$component.querySelector(this.SELECTORS.navBar),
      searchBtn: this.$component.querySelector(this.SELECTORS.searchBtn),
      searchLayer: document.querySelector(this.SELECTORS.searchLayer),
      searchLayerInput: document.querySelector(this.SELECTORS.searchLayerInput),
      submenuLinks: this.$component.querySelectorAll(this.SELECTORS.submenuLinks),
      submenuAccessibilityButtons: this.$component.querySelectorAll(this.SELECTORS.submenuAccessibilityButton),
      menuLayers: document.querySelector(this.SELECTORS.menuLayers),
      backMainMenu: document.querySelectorAll(this.SELECTORS.backMainMenu),
      redirectLinks: document.querySelectorAll(this.SELECTORS.redirectLink),
      wishlistIcon: this.$component.querySelectorAll(this.SELECTORS.wishlistIcon),
      wishlistCounter: this.$component.querySelectorAll(this.SELECTORS.wishlistCounter),
      myaccountIcon: this.$component.querySelector(this.SELECTORS.myaccountIcon),
      myAccountLayerAccessibiltyBtn: this.$component.querySelector(this.SELECTORS.myAccountLayerAccessibiltyBtn),
      myAccountLayer: document.querySelector(this.SELECTORS.myAccountLayer),
      currentMenuEnabled: null,
      currentSubmenuEnabled: null,
      isMobileMenuOpen: false
    }
  }

  // FIRST LEVEL MENU //
  handleMobileMenu() {
    if(this.dom.burgerMenu) {
      this.dom.burgerMenu.addEventListener("click", () => {
        this.toggleMobileMenu();
        // communication popup timer events //
        if (this.dom.isMobileMenuOpen) {
          // communication popup resume timer //
          this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
        } else {
          // communication popup stop timer //
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
        if(window.innerWidth < 1024)  {
          this.$emit(this.$customEvents.MENU_EVENTS.showMenu);
        }
      });
    }
  }

  toggleMobileMenu() {
    const benefitBars = document.querySelectorAll("[data-benefit-bar]");
    if(benefitBars) {
      benefitBars.forEach(benefitBar => {
        benefitBar.classList.toggle("hidden");
      });
    }
    const headerMenuHeight =  this.dom.headerMenu.clientHeight;
    this.dom.navBar.style.top = headerMenuHeight + "px";
    const navbarHeight = window.innerHeight - headerMenuHeight;
    this.dom.navBar.style.height = navbarHeight + "px";
    this.dom.navBar.classList.toggle("--opened");
    this.dom.navBar.classList.toggle("--closed");
    this.dom.burgerMenu.classList.toggle("--opened");
    this.dom.menuLayers.classList.add("--closed");
    document.body.classList.toggle("--no-overflow");
    if(this.dom.currentSubmenuEnabled) {
      this.dom.currentSubmenuEnabled.classList.add("hidden");
      this.dom.currentSubmenuEnabled = null;
    }
    this.dom.isMobileMenuOpen ? this.dom.isMobileMenuOpen = false : this.dom.isMobileMenuOpen = true;
  }

  // if screen size is table/mobile set navbar height otherwise reset it
  handleMobileMenuHeight() {
    window.addEventListener("resize", () => {
      if(this.dom.navBar) {
        if(window.innerWidth < 1024)  {
          const headerMenuHeight =  this.dom.headerMenu.clientHeight;
          const navbarHeight = window.innerHeight - headerMenuHeight;
          this.dom.navBar.style.height = navbarHeight + "px";
        } else {
          this.dom.navBar.style.height = "";
        }
      }
    })
  }

  handleSubmenuLayers(trigger, event) {
    if(this.dom.currentMenuEnabled === event.currentTarget) {
      this.closeSubmenu();
    } else {
      // if this.dom.currentMenuEnabled then remove --active and empty field
      if(this.dom.currentMenuEnabled) {
        this.dom.currentMenuEnabled.classList.remove("--active");
        this.dom.currentMenuEnabled = null;
      }
      //if this.dom.currentSubmenuEnabled then hide and empty field
      if(this.dom.currentSubmenuEnabled) {
        this.dom.currentSubmenuEnabled.classList.add("hidden");
        this.removeEventListener();
        this.dom.currentSubmenuEnabled = null;
      }
      this.dom.menuLayers.classList.remove("--closed");
      const submenuName = trigger.dataset.menuItem;
      const submenuPanel = document.querySelector("[data-menu-panel='"+submenuName+"']");
      if(submenuPanel) {
        submenuPanel.classList.remove("hidden");
        this.dom.currentSubmenuEnabled = submenuPanel;
        this.originalSubmenuLink = trigger;

        // trapfocus management
        this.submenuFocusHandler = trapFocusOnModal(submenuPanel);

        // escape management submenu
        submenuPanel.addEventListener("keydown", event => {
          if (event.key === "Escape") {
            this.closeSubmenu();
          }
        });

        // handle click outside menu layer in desktop //
        if(window.innerWidth >= 1024) {
          trigger.classList.add("--active");
          this.dom.currentMenuEnabled = trigger;
          event.stopPropagation();
          document.addEventListener("click", this.handleClickOutsideSubmenuLayer.bind(this));
        } else {
          this.dom.menuLayers.style.top =  this.dom.menuLayers.getBoundingClientRect().top + "px";
          this.dom.menuLayers.style.position = "fixed";
          this.dom.menuLayers.style.bottom = "0";
        }
        // communication popup pause timer //
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
        document.body.dataset.jsLayerIsOpen = "true";
      }
      //close search layer
      this.dom.searchLayer.classList.remove("--opened");
    }
  }

  // SUBMENU HANDLE //
  handleSubmenuLinks() {
    if(this.dom.submenuLinks) {
      this.dom.submenuLinks.forEach(submenuLink => {
        submenuLink.addEventListener("click", (event) => {
          this.handleSubmenuLayers(submenuLink, event);
        });
      });
    }
    if(this.dom.submenuAccessibilityButtons) {
      this.dom.submenuAccessibilityButtons.forEach(submenuButton => {
        submenuButton.addEventListener("click", (event) => {
          this.handleSubmenuLayers(submenuButton, event);
        });
      });
    }
  }

  handleClickOutsideSubmenuLayer(event) {
    if(this.dom.currentSubmenuEnabled && !this.dom.currentSubmenuEnabled.contains(event.target)) {
      this.closeSubmenu();
    }
  }

  removeEventListener() {
    document.removeEventListener("click", this.handleClickOutsideSubmenuLayer);
  }

  // Manage escape to close submenu
  handleSubmenuEscape(e) {
    if (e.key === "Escape") {
      this.closeSubmenu();
    }
  }

  closeSubmenu() {
    if(this.dom.currentSubmenuEnabled) {
      this.dom.currentSubmenuEnabled.classList.add("hidden");
      this.dom.menuLayers.classList.add("--closed");
    }
    if(this.dom.currentMenuEnabled) {
      this.dom.currentMenuEnabled.classList.remove("--active");
      this.dom.currentMenuEnabled = null;
    }
    removeTrapFocusOnModal(this.dom.currentSubmenuEnabled, this.submenuFocusHandler);
    this.dom.currentSubmenuEnabled = null;
    this.removeEventListener();
    // communication popup resume timer //
    this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
    document.body.dataset.jsLayerIsOpen = "false";

    // reset focus
    if (this.originalSubmenuLink) {
      setTimeout(() => {
        // find focusable element
        const focusableElement = this.originalSubmenuLink.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        if (focusableElement) {
          focusableElement.focus();
        } else if(this.originalSubmenuLink.hasAttribute('data-navigation-accessibility-button')) {
          this.originalSubmenuLink.focus();
        }
        this.originalSubmenuLink = null;
      }, 50);
    }
  }

  closeMobileSubmenu() {
    if(this.dom.backMainMenu) {
      this?.dom?.backMainMenu?.forEach(element => {
        element.addEventListener("click", () => {
          this.dom.menuLayers.classList.add("--closed");
          if(this.dom.currentSubmenuEnabled) {
            this.dom.currentSubmenuEnabled.classList.add("hidden");
            this.dom.currentSubmenuEnabled = null;
          }
        });
      });
    }
  }

  // HANDLE SUBMENU CARDS //
  handleRedirectLink() {
    if(this.dom.redirectLinks) {
      this.dom.redirectLinks.forEach(link => {
        link.addEventListener("click", () => {
          window.location.href = link.dataset.cardHref;
        });
      });
    }
  }


  // SEARCH LAYER //
  handleSearchLayer() {
    if(this.dom.searchBtn) {
      // focus the input (call readDOM() because algolia input arrives after render)Add commentMore actions
      this.dom.searchLayer.addEventListener("transitionend", (event) => {
        if (
          this.dom.searchLayer.classList.contains("--opened") &&
          this.readDOM().searchLayerInput
        ) {
          this.readDOM().searchLayerInput.focus();
        }
      });
      this.dom.searchBtn.addEventListener("click", () => {
        // layer is closed --> add --opened
        if(!this.dom.searchLayer.classList.contains("--opened")) {
          this.dom.searchLayer.classList.add("--opened");
          // focus the input (call readDOM() because algolia input arrives after render)
          this.readDOM().searchLayerInput ? this.readDOM().searchLayerInput.focus() : '';
          // communication popup stop timer //
          this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
          document.body.dataset.jsLayerIsOpen = "true";
          if (window.matchMedia('(max-width: 768px)').matches) {
            document.body.classList.add("--no-overflow");
            const benefitBars = document.querySelectorAll("[data-benefit-bar]");
            if(benefitBars) {
              benefitBars.forEach(benefitBar => {
                benefitBar.classList.add("hidden");
              });
            }
          }
          //in mobile close menu
          if(window.innerWidth < 1024 && this.dom.isMobileMenuOpen)  {
            this.toggleMobileMenu();
          }
        }
      });
    }
  }

  // WISHLIST API //
  updateWishlistIcon(qty) {
    if(this.dom.wishlistIcon) {
      this.dom.wishlistIcon.forEach(wishlistIcon => {
        wishlistIcon.classList.remove((qty > 0) ? this.CLASSES.iconWishlistEmpty : this.CLASSES.iconWishlistFull);
        wishlistIcon.classList.add((qty > 0) ? this.CLASSES.iconWishlistFull : this.CLASSES.iconWishlistEmpty);
      });
    }
  }

  handleAccessibilityButton() {
    this.dom.myAccountLayerAccessibiltyBtn.addEventListener("click", () => {
      this.dom.myAccountLayerAccessibiltyBtn.classList.toggle("--opened");
      this.dom.myaccountIcon.classList.toggle("--open");
      if(this.dom.myAccountLayerAccessibiltyBtn.classList.contains("--opened")) {
        this.dom.myAccountLayerAccessibiltyBtn.setAttribute("aira-expanded","true");
        this.trapFocusHandler = trapFocusOnModal(this.dom.myAccountLayer);
        this.dom.myAccountLayer.addEventListener('keydown', event => {
          if(event.key === "Escape") {
            this.dom.myAccountLayerAccessibiltyBtn.setAttribute("aira-expanded","false");
            this.dom.myAccountLayerAccessibiltyBtn.classList.remove("--opened");
            this.dom.myaccountIcon.classList.remove("--open");
            removeTrapFocusOnModal(this.dom.myAccountLayer, this.trapFocusHandler);
            this.trapFocusHandler = null;
            this.dom.myAccountLayerAccessibiltyBtn.focus();
          }
        });
      } else {
        this.dom.myAccountLayerAccessibiltyBtn.setAttribute("aira-expanded","false");
        this.dom.myAccountLayerAccessibiltyBtn.classList.remove("--opened");
        this.dom.myaccountIcon.classList.remove("--open");
      }
    });
    this.$on(this.$customEvents.ACCOUNT_LAYER_EVENTS.showResetPassword, ({event, payload}) => {
      removeTrapFocusOnModal(this.dom.myAccountLayer, this.trapFocusHandler);
    });
    this.$on(this.$customEvents.ACCOUNT_LAYER_EVENTS.showLoginForm, ({event, payload}) => {
      removeTrapFocusOnModal(this.dom.myAccountLayer, this.trapFocusHandler);
    });
  }

  bindEvents() {
    this.handleMobileMenu();
    this.handleMobileMenuHeight();
    this.handleSearchLayer();
    this.handleSubmenuLinks();
    this.closeMobileSubmenu();
    this.handleRedirectLink();
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({event, payload}) => {
      this.updateWishlistIcon(payload.qty);
    });
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      this.updateWishlistIcon(payload.qty);
    });
    if(this.dom.myaccountIcon) {
      this.dom.myaccountIcon.addEventListener("mouseover", event => {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      });
      this.dom.myaccountIcon.addEventListener("mouseout", event => {
        if(document.body.dataset.jsLayerIsOpen == "false") {
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
      });
      this.handleAccessibilityButton();
    }
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
